import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { t } from "i18next";
import { IconLocation, IconDelivery, IconPhone } from "icons";
import { useCustomHistory, useLang } from "hooks";


const Footer = () => {
  const params = useParams();
  const {isArabic } = useLang();
  const router = useCustomHistory();
  const [showLinks, setShowLinks] = useState(false);
  const [pages, setPages] = useState([]);
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);

  const tagLine = isArabic ? "taglineAR" : "taglineEN";

  const { DomainType, selectedStore } = useSelector((state) => ({
    DomainType: state.AppReducer.DomainType,
    selectedStore: state.store.selectedStore,
  }));
  const getActiveLinks = useMemo(() => {
    const activeLinks = Object.values(
      brandInfo?.setting?.staticPages || {}
    ).filter((key) => key?.isActive);
    return activeLinks.length > 0;
  }, [brandInfo?.setting?.staticPages]);

  useEffect(() => {
    setPages(brandInfo?.setting?.staticPages);
    setShowLinks(getActiveLinks);
    return () => setShowLinks(false);
  }, []);

  const gotoMyPage = (pageData) => {
    const DominaName =
      brandInfo?.setting?.temporaryDomainName || params?.domainName;
    if (pageData) {
      router(
        `/pages/s/${pageData[0]}`,
        `/${DominaName}/pages/s/${pageData[0]}`,
        DomainType,
        pageData[1]
      );
    }
  };

  const paymentOptions = [
    {
      alt: "master-card",
      src: "/images/card_master.png",
    },
    {
      alt: "visa-card",
      src: "/images/card_visa.png",
    },
    {
      alt: "union-bank",
      src: "/images/unioun-bank.png",
    },
  ];

  return (
    <footer
      id="footer"
      className="p-4 text-brand-text-primary bg-brand-base-primary flex flex-col gap-4"
    >
      <div className="flex flex-col gap-2">
        <h4 className="font-nunito ft-head">{brandInfo?.brand?.brandName}</h4>
        {brandInfo?.setting?.[tagLine]?.trim() &&
         <p >
            {brandInfo?.setting?.[tagLine]}
          </p>
        }
        
        {selectedStore && (
          <h5 className="font-nunito">{selectedStore?.baseLanguage?.name}</h5>
        )}
      </div>

     {selectedStore && <ul className="ft-contact">
        {selectedStore?.averagePrepTime && (
          <li>
            <span className="svg-icon">
              <IconDelivery stroke="#FFFFFF" size="24" />
            </span>
            {t("Delivery happens within")} {selectedStore?.averagePrepTime}
          </li>
        )}
        {selectedStore?.mobileNumber && (
          <li>
            <span className="svg-icon">
              <IconPhone stroke="#FFFFFF" size="24" />
            </span>
            <span dir="ltr"> {selectedStore?.mobileNumber}</span>
          </li>
        )}
        {selectedStore?.manualAddress && (
          <li>
            <span className="svg-icon">
              <IconLocation stroke="#FFFFFF" size="24" />
            </span>
            {selectedStore?.manualAddress}
          </li>
        )}
      </ul>}
      {showLinks && (
        <React.Fragment>
          <div className="ft-head font-nunito">{t("Links")}</div>
          <ul>
            {pages &&
              Object.entries(pages)
                .filter((key) => key[1]?.isActive)
                .map((key) => (
                  <li key={key[0]} onClick={() => gotoMyPage(key)}>
                    <span className="cursor-pointer">
                      {isArabic
                        ? key[1]?.linkTitle?.ar
                        : key[1]?.linkTitle?.en}
                    </span>
                  </li>
                ))}
          </ul>
        </React.Fragment>
      )}

      <div className="flex flex-col gap-2">
        <h4 className="m-0 text-20x font-semibold">{t("Accepted Cards")}</h4>
        <ul className="flex">
          {paymentOptions?.map((pay) => (
            <li key={pay.alt}>
              <img
                alt={pay.alt}
                src={pay.src}
                className="inline-block mx-2"
                width={50}
              />
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
